<template>
  <div class="msgtypeChatrecord">
    <div
      class="msgtypeChatrecord_box"
      :class="item_type ? 'item_type_box' : ''"
      @click="item_type_box"
    >
      <h3>{{ items.content.title }}的聊天记录</h3>
      <p v-for="(item, index) in items.content.item" :key="index">
        <span>{{ state_list[item.type] }}</span>
        <span v-if="item.type === 'ChatRecordText'">{{ item.content.content }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  filters: {
    ellipsis(value) {
      if (!value) return '';
      const content = value.replace('"', '').replace(/[\\]/g, '');
      return content;
    },
  },
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      proportion: false,
      state_list: {
        ChatRecordImage: '[图片消息]',
        ChatRecordText: '[文本消息]',
        ChatRecordRevoke: '[撤回消息]',
        ChatRecordAgree: '[同意消息]',
        ChatRecordDisagree: '[不同意消息]',
        ChatRecordVoice: '[语音消息]',
        ChatRecordVideo: '[视频消息]',
        ChatRecordCard: '[名片消息]',
        ChatRecordLocation: '[位置消息]',
        ChatRecordEmotion: '[表情消息]',
        ChatRecordFile: '[文件消息]',
        ChatRecordLink: '[链接消息]',
        ChatRecordWeapp: '[小程序消息]',
        ChatRecordChatrecord: '[聊天记录消息]',
        ChatRecordTodo: '[待办消息]',
        ChatRecordVote: '[投票消息]',
        ChatRecordCollect: '[填表消息]',
        ChatRecordRedpacket: '[红包消息]',
        ChatRecordMeeting: '[会议邀请消息]',
        ChatRecordDocmsg: '[在线文档消息]',
        ChatRecordMarkdown: '[MarkDown格式消息]',
        ChatRecordNewsnews: '[图文消息]',
        ChatRecordCalendar: '[日程消息]',
        ChatRecordMixed: '[混合消息]',
        ChatRecordMeetingVoiceCall: '[音频存档消息]',
        ChatRecordVoip_docShare: '[音频共享文档消息]',
        ChatRecordExternalRedpacket: '[互通红包消息]',
      },
      item_type: false,
    };
  },
  mounted() {
    const imgObj = new Image();
    imgObj.src = this.items.cos_file_url;
    imgObj.onload = () => {
      if (imgObj.width > imgObj.height) {
        this.proportion = true;
      }
    };
  },
  methods: {
    item_type_box() {
      this.item_type = !this.item_type;
    },
  },
};
</script>

<style scoped lang="scss">
.msgtypeChatrecord {
  padding: 0 12px;
  box-sizing: border-box;
  .msgtypeChatrecord_box {
    width: 258px;
    height: 120px;
    padding: 12px;
    overflow: hidden;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    box-sizing: border-box;
    h3 {
      margin-bottom: 5px;
      font-size: 16px;
      line-height: 28px;
      color: #303133;
    }
    p {
      overflow: hidden;
      font-size: 12px;
      line-height: 24px;
      color: #606266;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .item_type_box {
    height: auto;
  }
}
</style>
